import ExtendStore from 'src/stores/base/extendStore';
import { Stores } from 'src/stores';
import { action, observable, runInAction } from 'mobx';
import ZjStore from '../../zjStore';
import zhejiangApi from 'src/custom/zhejiang/apis/zhejiangApi'
import { message } from 'antd'

export default class IndexStore extends ExtendStore {
    @observable
    public currBanner: any; // 当前选中的banner
    @observable
    public bannerList: any[] = [] // 首页banner列表
    @observable
    public thumbList: any[] = [] // 首页banner列表
    @observable
    public isClickBanner: boolean = true // 控制是否触发首页轮播图点击事件
    private zjStore: ZjStore;

    public constructor(stores: Stores, zjStore: ZjStore) {
        super(stores);
        this.zjStore = zjStore;
    }

    //获取bannerList
    @action
    public getBannerList(type?: string) {
        return new Promise((resolve, reject) => {
            zhejiangApi.queryStatisticsPicture('frontpage').then(res => {
                runInAction(() => {
                    if (res.data.success && res.data.data) {
                        this.bannerList = res.data.data
                        this.setCurrBanner(this.bannerList[0])
                    }
                    resolve(true)
                })
            }, res => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title);
                }
            })
        })
    }

    @action
    public getThumbList() {
        return new Promise((resolve, reject) => {
            zhejiangApi.queryStatisticsPicture('topicarea').then((res) => {
                runInAction(() => {
                    if (res.data.success && res.data.data) {
                        this.thumbList = res.data.data
                    }
                    resolve(true)
                })
            }, res => {
                if (res.data.error && res.data.error.title) {
                    message.error(res.data.error.title);
                }
                reject()
            })
        })
    }

    @action
    public setCurrBanner(banner: any) {
        this.currBanner = banner;
    }

    @action
    public setThumbList(thumbList: any) {
        this.thumbList = thumbList;
    }

    @action
    public setIsClickBanner(payload: boolean) {
        this.isClickBanner = payload;
    }
}